// The admin feature (ADR 0007, temporary): the organization's accounts for admins, and the
// organization itself for super admins.
import { Building2Icon, UsersIcon } from "lucide-react";
import { registerNav } from "../../app/registry/nav";
import { routes } from "../context";

registerNav({
  id: "admin:users",
  group: "admin",
  labelKey: "admin.users.nav",
  icon: UsersIcon,
  to: () => routes.adminUsers(),
  order: 20,
  visibleTo: ["tenant-admin", "admin"],
});

registerNav({
  id: "admin:organization",
  group: "admin",
  labelKey: "admin.organization.nav",
  icon: Building2Icon,
  to: () => routes.adminOrganization(),
  order: 30,
  visibleTo: ["tenant-admin"],
});
